import { VSwitch } from 'vuetify/lib/components/VSwitch';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VSwitch,{attrs:{"label":_vm.$t('Overview mode'),"hide-details":"auto"},model:{value:(_vm.isOverview),callback:function ($$v) {_vm.isOverview=$$v},expression:"isOverview"}})}
var staticRenderFns = []

export { render, staticRenderFns }